<div class="h-full" *ngIf="isPageReady" style="max-width: 8.5in; min-width: 8.5in">
  <app-restock-fee-invoice #printableArea [account]="account" [returnRequestDetails]="returnRequestDetails"></app-restock-fee-invoice>
</div>
